export default __webpack_public_path__ + "static/media/Marking-Paints.a45396b8.jpg";